import ApiService from '../services/ApiService';

export const CAL_GET_CUSTINFO = 'CAL_GET_CUSTINFO';
export const CAL_GET_ROINFO = 'CAL_GET_ROINFO';
export const CAL_GET_EVENTS = 'CAL_GET_EVENTS';
export const CAL_GET_GROUPS = 'CAL_GET_GROUPS';
export const CAL_GET_USERS = 'CAL_GET_USERS';
export const CAL_GET_GROUP_USERS = 'CAL_GET_GROUP_USERS';
export const CAL_GET_GROUP_CATEGORIES = 'CAL_GET_GROUP_CATEGORIES';
export const CAL_GET_GROUP_CATEGORY = 'CAL_GET_GROUP_CATEGORY';
export const CAL_GET_TEMPLATES = 'CAL_GET_TEMPLATES';
export const CAL_SET_EVENT = 'CAL_SET_EVENT';
export const CAL_DELETE_EVENT = 'CAL_DELETE_EVENT';
export const CAL_GET_SS_CODES = 'CAL_GET_SS_CODES';
export const CAL_GET_CAL_CONFIG = 'CAL_GET_CAL_CONFIG';
export const CAL_GET_CAL_BAYS = 'CAL_GET_CAL_BAYS';

export function getCalBays() {
  return {
    type: CAL_GET_CAL_BAYS,
    payload: ApiService.get('/bays'),
  };
}

export function getCalConfig(userId) {
  return {
    type: CAL_GET_CAL_CONFIG,
    payload: ApiService.get(`/event/config/user/${userId}`),
  };
}

export function getCustomerInfo(custNo) {
  return {
    type: CAL_GET_CUSTINFO,
    payload: ApiService.get(`/customer/${custNo}/parts`),
  };
}

export function getRepairOrderInfo(roNo) {
  return {
    type: CAL_GET_ROINFO,
    payload: ApiService.get(`/roInfo/${roNo}`),
  };
}

// TODO Needs to accept date range
export function getEvents(startDate, eventId) {
  const params = {
    eventId,
  };

  if (startDate === 'today') {
    params.today = true;
  } else {
    params.startDate = startDate;
  }

  return {
    type: CAL_GET_EVENTS,
    payload: ApiService.get('/events', { params }),
  };
}

export function getGroups() {
  return {
    type: CAL_GET_GROUPS,
    payload: ApiService.get('/event/groups'),
  };
}

export function getUsers() {
  return {
    type: CAL_GET_USERS,
    payload: ApiService.get('/event/users'),
  };
}

export function getGroupUsers() {
  return {
    type: CAL_GET_GROUP_USERS,
    payload: ApiService.get('/event/groupUsers'),
  };
}

export function getGroupCategories() {
  return {
    type: CAL_GET_GROUP_CATEGORIES,
    payload: ApiService.get('/event/groupCategories'),
  };
}

export function getSSCOdes() {
  return {
    type: CAL_GET_SS_CODES,
    payload: ApiService.get('/ssCodes'),
  };
}

export function getGroupCategory() {
  return {
    type: CAL_GET_GROUP_CATEGORY,
    payload: ApiService.get('/event/groupCategory'),
  };
}

export function getTemplates() {
  return {
    type: CAL_GET_TEMPLATES,
    payload: ApiService.get('/event/templates'),
  };
}

export function setEvent(eventId, eventData) {
  return {
    type: CAL_SET_EVENT,
    payload: ApiService.put(`/event/${eventId}`, eventData),
  };
}

export function deleteEvent(eventId) {
  return {
    type: CAL_DELETE_EVENT,
    payload: ApiService.delete(`/event/${eventId}`),
  };
}
